import axios from "axios";
import { useMutation } from "react-query";

const UseGet = (queryKey, options = {}) => {
    const token = document.cookie.split(`jwt=`).pop().split(';').shift();
  
    return useMutation(
      queryKey,
      async (url) => {
        const { data } = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        return data;
      },
      {
        staleTime: 1000 * 60 * 5,
        retry: 2,
        ...options,
      }
    );
  };
  

export default UseGet;
